import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getUserData, getUserAnswers } from 'routes/Profile/modules/actions';
import { loadingAction } from 'store/globalState/global';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';
import ReactGA from 'react-ga';
import {
  TAB_RESUME, TAB_DATA,
} from 'constants/profile';
import Slider from 'react-slick';
import { decodeHTML } from 'utils/data';
import apiFetch from 'utils/apiFetch';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ConnectionUser from 'routes/Connections/components/ConnectionUser';
import PrivacyElement from 'routes/Profile/components/PrivacyElement';
import {
  UserCardWrapper, Close, AvatarWrapper, UserAvatar, UserName, MainButtons, ButtonNormal, ButtonDanger,
  ProfileTabs, ProfileTab, ButtonSuccess, TabContent, ProfileContent, ProfileSection, ProfileAnswer,
  ConnectionsWrapper, ProfileSectionTitle, NarrativeTitle, NarrativeQuestions, RelationsList,
  ButtonEditResume, TextLabel, Combobox, NoData,
} from './styles';
import './styles.css';


class UserCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: props.userData,
      tabSelected: TAB_RESUME,
      answers: props.answers,
      editMode: false,
    };
  }

  componentDidMount() {
    const { user: { id } } = this.props;
    const { user, answers } = this.state;
    if (!user || !answers) {
      if (!user) {
        loadingAction(true);
        getUserData(id)
          .then((userData) => {
            this.setState({
              user: userData.info,
            });
            loadingAction(false);
          });
      }

      if (!answers) {
        getUserAnswers(id)
          .then((response) => {
            this.setState({ answers: response });
          });
      }
    }

    window.scrollTo(0, 0);
  }

  componentDidUpdate = ({ userData: prevUser, answers: prevAnswers }) => {
    const { userData, answers } = this.props;

    if (JSON.stringify(prevUser) !== JSON.stringify(userData)) {
      this.setState({ user: userData });
    }

    if (JSON.stringify(prevAnswers) !== JSON.stringify(answers)) {
      this.setState({ answers });
    }
  }

  filterActions = (array) => {
    const actions = {};

    array.map((action) => {
      if (typeof actions[action.aType] === 'undefined') actions[action.aType] = [];

      actions[action.aType].push(action);

      return action;
    });

    return actions;
  }

  filterConnections = (array) => {
    const newArray = [];

    array.map((connection) => {
      if (typeof newArray.find(c => c.id === connection.id) === 'undefined') {
        newArray.push(connection);
      }
      return connection;
    });

    return newArray;
  };

  handleClose = () => {
    const { onClose } = this.props;
    onClose();
  }

  handleViewResume = () => {
    this.setState({ tabSelected: TAB_RESUME, editMode: false });
  }

  handleViewData = () => {
    this.setState({ tabSelected: TAB_DATA, editMode: false });
  }

  printTabContent = () => {
    const { tabSelected } = this.state;
    switch (tabSelected) {
      case TAB_DATA:
        return this.printData();
      default:
        return this.printResume();
    }
  }

  handleEnableEdition = () => {
    this.setState({ editMode: true });
  }

  handleDisableEdition = () => {
    this.setState({ editMode: false });
  }

  handleChangeResumeField = name => (event) => {
    const value = event.target.value;
    const { user } = this.state;
    user.profile[name] = value;
    this.setState({ user });
  };

  saveResumeEdition = () => {
    const { user } = this.state;
    const { updateProfile } = this.props;

    const params = {
      name: user.firstname,
      surname: user.lastname,
      avatar: user.avatar,
    };

    _.forEach(user.profile, (value, key) => {
      params[key] = value;
    });

    updateProfile(params);
    this.handleDisableEdition();
  };

  printResumeEdition = () => {
    const { user } = this.state;
    const { literals, color } = this.props;
    const darkerColor = typeof color === 'string' ? color : color.color;

    const summaryFields = _.map(user.profile, (value, field) => {
      switch (field) {
        case 'gender':
          return (
            <React.Fragment key={`adornment-${field}`}>
              <TextLabel className='form__field' htmlFor='gender-simple'>{literals[field]}</TextLabel>
              <Combobox
                native
                value={value}
                onChange={this.handleChangeResumeField(field)}
                inputProps={{
                  name: 'gender',
                  id: 'gender-simple',
                  className: 'form__field__input',
                }}
                className='form__field'
              >
                <option value='female'>{literals.female}</option>
                <option value='male'>{literals.male}</option>
              </Combobox>
            </React.Fragment>
          );
        default:
          return (
            <TextField
              id={`adornment-${field}`}
              key={`adornment-${field}`}
              label={literals[field]}
              multiline
              rowsMax={4}
              value={decodeHTML(value)}
              onChange={this.handleChangeResumeField(field)}
              className='form__field'
              inputProps={{
                className: 'form__field__input',
              }}
            />
          );
      }
    });

    return (
      <ProfileContent color={darkerColor}>
        {summaryFields}
        <ButtonEditResume
          onClick={this.saveResumeEdition}
        >
          {literals.save}
        </ButtonEditResume>
      </ProfileContent>
    );
  }

  printResume = () => {
    const { literals, color, edit } = this.props;
    const darkerColor = typeof color === 'string' ? color : color.color;
    const state = this.state;
    const {
      user, editMode,
    } = state;

    if (editMode) {
      return this.printResumeEdition();
    }
    let isEmptyResume = true;

    const fields = _.map(user.profile, (value, field) => {
      if (decodeHTML(value)) {
        isEmptyResume = false;
        return (
          <React.Fragment key={field}>
            <ProfileSection>
              {literals[field]}
            </ProfileSection>
            <ProfileAnswer>
              {(field === 'gender' ? literals[value] : decodeHTML(value)) || ''}
            </ProfileAnswer>
          </React.Fragment>
        );
      }
      return <React.Fragment></React.Fragment>;
    });

    if (isEmptyResume) {
      return (
        <NoData>
          {literals.noInfo}
        </NoData>
      );
    }
    return (
      <ProfileContent color={darkerColor}>
        {fields}
        {edit ? (
          <ButtonEditResume
            onClick={this.handleEnableEdition}
          >
            {literals.edit}
          </ButtonEditResume>
        ) : null}
      </ProfileContent>
    );
  }

  handleClickUser = (id) => {
    const { viewUserProfile } = this.props;
    viewUserProfile(id);
  }

  printData = () => {
    const { app } = this.props;
    const {
      answers,
    } = this.state;
    const darkerColor = app.color1;
    const narratives = _.map(answers, (narrative) => {
      let questionsCount = 0;
      const questions = _.map(narrative.questions, (question) => {
        if (!question.answers.length) {
          return null;
        }

        questionsCount += 1;

        const answersElements = _.map(question.answers, (element) => {
          return (
            <PrivacyElement
              level={0}
              color={darkerColor}
              element={element}
              key={element.id}
            />
          );
        });
        return (
          <React.Fragment key={question.id}>
            <ProfileSection
              color={darkerColor}
            >
              <ProfileSectionTitle dangerouslySetInnerHTML={{ __html: question.title }} />
            </ProfileSection>
            {answersElements}
          </React.Fragment>
        );
      });

      if (!questionsCount) {
        return null;
      }

      return (
        <React.Fragment key={narrative.id}>
          <NarrativeTitle color={darkerColor}>
            {narrative.name}
          </NarrativeTitle>
          <NarrativeQuestions>
            {questions}
          </NarrativeQuestions>
        </React.Fragment>
      );
    });

    return (
      <RelationsList>
        {narratives}
      </RelationsList>
    );
  }

  handleConnect = () => {
    const { user } = this.state;
    const { id } = user;
    const params = {
      userId: id,
      action: 'connect',
    };

    apiFetch('POST', { endPoint: 'users/connection' }, params);

    user.match_actual_user = 1;
    this.setState({ user });

    ReactGA.event({
      category: 'Add Connection User',
      action: `user_${id}`,
      label: 'User Card',
    });
  }

  handleDeleteConnection = () => {
    const { user } = this.state;
    const { id } = user;
    const params = {
      userId: id,
      action: 'connect',
    };

    apiFetch('DELETE', { endPoint: 'users/connection' }, params);

    user.match_actual_user = 0;
    this.setState({ user });

    ReactGA.event({
      category: 'Remove Connection User',
      action: `user_${id}`,
      label: 'User Card',
    });
  }

  handleSendMessage = () => {
    const { user } = this.state;
    const { addNewChat, history, viewUserProfile } = this.props;

    const params = {
      user: user.id,
    };

    apiFetch('POST', { endPoint: 'chat' }, params)
      .then((chat) => {
        addNewChat(chat);
        viewUserProfile(0);
        history.push(`/chat/${chat.id}`);
      });
  }

  printUsersConnections = () => {
    const { connections } = this.state;

    const mySettings = {
      arrows: false,
      slidesToShow: 8,
      cssEase: 'linear',
      swipe: true,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 7,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 601,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    };

    return (
      <ConnectionsWrapper>
        <Slider
          {...mySettings}
          ref={(carousel) => { this.carousel = carousel; }}
        >
          {connections.map((connection, index) => {
            return (
              <ConnectionUser key={index} onClick={this.handleClickUser} connection={connection} />
            );
          })}
        </Slider>
      </ConnectionsWrapper>
    );
  }

  render() {
    const {
      literals, color, onClose, showButtons,
    } = this.props;
    const { user, tabSelected } = this.state;

    if (!user) {
      return null;
    }

    const { avatar, firstname, lastname } = user;
    const backColor = typeof color === 'string' ? color : color.color;
    return (
      <UserCardWrapper className='UserCard' color={backColor}>
        {onClose && (
          <Close onClick={this.handleClose}>
            <i className='fa fa-times' />
          </Close>
        )}
        <Grid container spacing={0} className='Profile__panel'>
          <Grid item xs={12} sm={12} md={12} className='Profile__panel--right'>
            <div className='UserCard__panel--right__content'>
              <div className='UserCard__panel--right__content__form'>
                {(avatar && avatar !== '') ? (
                  <AvatarWrapper>
                    <UserAvatar alt={firstname} src={avatar} />
                  </AvatarWrapper>
                ) : (
                  <AvatarWrapper>
                    <UserAvatar className='text-avatar'>
                      {firstname && firstname !== '' && firstname.slice(0, 1)}
                    </UserAvatar>
                  </AvatarWrapper>
                )}
                <UserName>
                  {`${firstname} ${lastname}`}
                </UserName>
                {showButtons ? (
                  <MainButtons>
                    <React.Fragment>
                      {user.match_user && user.match_actual_user ? (
                        <ButtonNormal onClick={this.handleSendMessage}>
                          {literals.sendMessage}
                        </ButtonNormal>
                      ) : null}
                      {!user.match_actual_user ? (
                        <ButtonSuccess onClick={this.handleConnect}>
                          {literals.connect}
                        </ButtonSuccess>
                      ) : null}
                      {user.match_actual_user ? (
                        <ButtonDanger onClick={this.handleDeleteConnection}>
                          {literals.deleteConnection}
                        </ButtonDanger>
                      ) : null}
                    </React.Fragment>
                  </MainButtons>
                ) : null}
                <ProfileTabs>
                  <ProfileTab active={tabSelected === TAB_RESUME} onClick={this.handleViewResume}>
                    {literals.resume}
                  </ProfileTab>
                  <ProfileTab active={tabSelected === TAB_DATA} onClick={this.handleViewData}>
                    {literals.data}
                  </ProfileTab>
                </ProfileTabs>
                <TabContent>
                  {this.printTabContent()}
                </TabContent>
              </div>
            </div>
          </Grid>
        </Grid>
      </UserCardWrapper>
    );
  }
}

UserCard.propTypes = {
  onClose: PropTypes.func,
  user: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  color: PropTypes.string,
  addNewChat: PropTypes.func.isRequired,
  viewUserProfile: PropTypes.func.isRequired,
  userData: PropTypes.object,
  answers: PropTypes.array,
  showButtons: PropTypes.bool,
  updateProfile: PropTypes.func.isRequired,
  edit: PropTypes.bool,
};

UserCard.defaultProps = {
  color: '#fff',
  onClose: null,
  userData: null,
  answers: null,
  showButtons: true,
  edit: false,
};

export default UserCard;



// WEBPACK FOOTER //
// ./src/components/Steps/UserCard/components/UserCard.jsx